import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface GlobalPlayerState {
	isOpen: boolean
	isCollapsed: boolean
	position: {
		x: number
		y: number
	}
	content: {
		src: string
		cover?: string
		hideCover?: boolean
		title: string
		radioPrevText?: string
		radioTitle?: string
		metadata?: string[]
		onNext?: () => void
		onPrevious?: () => void
		disableNext?: boolean
		disablePrevious?: boolean
	} | null
	isPlaying: boolean
}

const initialState: GlobalPlayerState = {
	isOpen: false,
	isCollapsed: false,
	position: {
		x: 0, // centered
		y: 0, // bottom
	},
	content: null,
	isPlaying: false,
}

const globalPlayerSlice = createSlice({
	name: 'globalPlayer',
	initialState,
	reducers: {
		openPlayer: (
			state,
			action: PayloadAction<GlobalPlayerState['content']>
		) => {
			state.isOpen = true
			state.content = action.payload
			state.isCollapsed = false
			state.isPlaying = true
		},
		closePlayer: (state) => {
			state.isOpen = false
			state.isPlaying = false
		},
		toggleCollapse: (state) => {
			state.isCollapsed = !state.isCollapsed
		},
		setIsPlaying: (state, action: PayloadAction<boolean>) => {
			state.isPlaying = action.payload
		},
		updatePosition: (
			state,
			action: PayloadAction<GlobalPlayerState['position']>
		) => {
			state.position = action.payload
		},
		updateContent: (
			state,
			action: PayloadAction<Partial<NonNullable<GlobalPlayerState['content']>>>
		) => {
			if (state.content) {
				state.content = { ...state.content, ...action.payload }
			}
		},
	},
})

export const {
	openPlayer,
	closePlayer,
	toggleCollapse,
	updatePosition,
	updateContent,
	setIsPlaying,
} = globalPlayerSlice.actions

export const globalPlayerReducer = globalPlayerSlice.reducer
